import L from "leaflet";
import "leaflet/dist/leaflet.css";

const Leaflet = L?.default ?? L;
globalThis.L = Leaflet;

export default Leaflet;
export { Leaflet as L };
